"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The Url Rewrite module provides access to Url Rewrites from the EVA back-end
 *
 * @preferred
 */
var service_1 = require("../service");
var UrlRewrite;
(function (UrlRewrite) {
    "use strict";
    /**
     * Check if a certain request path needs rewriting
     * @return {Promise}    A promise resolving when the call to the back-end has completed
     *
     */
    function rewrite(requestPath) {
        // Create the service instance
        //
        var service = new service_1.EVAService("RewriteUrl");
        // Build the request data
        // The base class will add things like SessionID so keep typescript
        // happy we're using an 'any' type object here
        //
        var requestData = {
            Url: requestPath
        };
        return service.call(requestData);
    }
    UrlRewrite.rewrite = rewrite;
})(UrlRewrite = exports.UrlRewrite || (exports.UrlRewrite = {}));
